import { i18nFilter } from "app/filters/i18nFilter";
import type React from "react";
import { allTrackers } from "app/services/track/track";
import UnlockModal from "pro-features/components/Modals/src/UnlockModal/UnlockModal";
import type { UnlockModalSlides } from "pro-features/components/Modals/src/types";
import TrackProvider from "pro-features/components/WithTrack/src/TrackProvider";
import TranslationProvider from "pro-features/components/WithTranslation/src/TranslationProvider";

interface IUnlockModalWrapperProps {
    isOpen: boolean;
    onCloseClick?: () => void;
    onAfterOpen?: () => void;
    location: string;
    activeSlide?: string;
    slides: UnlockModalSlides<string>;
    ctaText: string;
    label: string;
}

const UnlockModalProvider: React.FunctionComponent<IUnlockModalWrapperProps> = (props) => (
    <TranslationProvider translate={i18nFilter()}>
        <TrackProvider track={allTrackers.trackEvent.bind(allTrackers)}>
            <UnlockModal {...props} />
        </TrackProvider>
    </TranslationProvider>
);

export default UnlockModalProvider;
